import { createStreamEpic } from '../../signalr/createStreamEpic'
import { fetchCustomerDefinition } from './definition'

export default createStreamEpic('customers.fetch', fetchCustomerDefinition)
